import { dateMethods } from '@/helpers/dateHelper';

export default class SearchCriteriaChipHelper {
  getSearchCriteriaChips(params) {
    if (JSON.stringify(params) === '{}') {
      return [];
    }
    const containsChips = this.getContainsChips(params.contains);
    const dateChip = this.getDateChip(params.dates);
    const accessibleByChips = this.getMultiChip({
      chipItems: params.accessibleBy,
      color: '#FE60C7',
      type: 'Accessible by',
      id: 'accessibleBy'
    });
    const fileExtensionsChips = this.getMultiChip({
      chipItems: params.fileExtension,
      type: 'File extension',
      color: '#58e2c2',
      id: 'fileExtensions'
    });
    const sourceType = this.getSingleChip({
      chipItem: params.sourceType,
      type: 'Source type ',
      color: '#1b2342',
      id: 'sourceType'
    });
    const fileNames = this.getMultiChip({
      chipItems: params.fileNames,
      type: 'File name',
      color: '#d5a4cf',
      id: 'fileNames'
    });
    const sourcePath = this.getSingleChip({
      chipItem: params.sourcePath,
      type: 'Directory ',
      color: '#8134af',
      id: 'sourcePath'
    });
    const attachmentsChips = this.getAttachmentTextChip(
      params.hasAttachments,
      params.attachments,
      'attachments'
    );
    const isBasedOnChip = this.getSingleChip({
      chipItem: params.basedOn,
      color: '#FE60C7',
      type: 'Based on ',
      id: 'search'
    });
    const isLatestChip = this.getIsLatestChip(params.isLatest, 'isLatest');
    const emailCategoryChip = this.getSingleChip({
      chipItem: params.emailCategory,
      color: '#7440FB',
      type: 'Email category ',
      id: 'emailCategory'
    });
    const subjectChips = this.getMultiChip({
      chipItems: params.subject,
      type: 'Subject',
      color: '#1b2342',
      id: 'subjectItems'
    });
    const fromChips = this.getMultiChip({
      chipItems: params.from,
      type: 'from',
      color: '#DADADA',
      id: 'fromEmailItems'
    });
    const toChips = this.getMultiChip({
      chipItems: params.to,
      type: 'to',
      color: '#DADADA',
      id: 'toEmailItems'
    });
    const eventGroupChip = this.getSingleChip({
      chipItem: params.eventGroup,
      color: '#8134af',
      type: 'Event group ',
      id: 'eventGroup'
    });
    const detailsItemChips = this.getMultiChip({
      chipItems: params.detailedItems,
      color: '#58e2c2',
      type: 'have details',
      id: 'detailedItems'
    });

    const eventChip = this.getSingleChip({
      chipItem: params.eventType,
      color: '#8134af',
      type: 'Event type ',
      id: 'eventType'
    });

    const searchCrieteraChips = [
      ...dateChip,
      ...fromChips,
      ...toChips,
      ...subjectChips,
      ...isBasedOnChip,
      ...containsChips,
      ...accessibleByChips,
      ...fileExtensionsChips,
      ...attachmentsChips,

      ...detailsItemChips,
      ...fileNames,
      ...eventGroupChip,
      ...eventChip,
      ...sourcePath,
      ...sourceType,

      ...isLatestChip,
      ...emailCategoryChip
    ];
    return searchCrieteraChips;
  }

  /**
   *
   * @param {Object<Array<Object>>} containsMap
   */
  getContainsChips(containsMap) {
    if (!containsMap) {
      return [];
    }
    let entries = Object.entries(containsMap);
    entries = entries.filter(entry => entry[1].length);
    if (!entries.length) {
      return '';
    }
    const containsTextArr = [];
    entries.forEach(entry => {
      containsTextArr.push({
        id: entry[0],
        val: `${entry[0].split('_').join(' ')} have text ${entry[1].join(', ')}`
      });
    });
    const containsChips = containsTextArr.map(({ val, id }) => ({
      val,
      color: '#FE60C7',
      id
    }));

    return containsChips;
  }

  /**
   *
   * @param { Object: { chipItem:String, color:String, type:String } } param0
   */
  getSingleChip({ chipItem, color, type, defaultItem = false, id }) {
    if (chipItem) {
      let chipVal = String(chipItem).split('_');
      return [
        {
          val: type + chipVal[0],
          color,
          defaultItem,
          default: chipVal[1] ? true : false,
          id
        }
      ];
    }
    return [];
  }

  /**
   *
   * @param { Object: { chipItem:Array, color:String, type:String } } param0
   */
  getMultiChip({ chipItems, color, type, id }) {
    if (!chipItems) {
      return [];
    }
    return chipItems.length
      ? [{ val: type + ' ' + chipItems.join(', '), color, id }]
      : [{ val: type + ' ' + 'anyone', color, default: true, id }];
  }

  /**
   *
   * @param {Boolean} isLatest
   */
  getIsLatestChip(isLatest, id) {
    if (typeof isLatest === 'boolean') {
      if (isLatest) {
        return [{ val: 'latest version', color: '#FE60C7', id }];
      }
      return [{ val: 'any version', color: '#FE60C7', id, default: true }];
    } else {
      return [];
    }
  }

  /**
   *
   * @param {Object} dateRange
   */
  getDateChip(dateRange) {
    if (dateRange.start === '' && dateRange.end === '') {
      return [
        {
          val: 'All time',
          color: '#7440FB',
          default: true,
          id: 'selectedRange'
        }
      ];
    }

    const formattedStartDate = dateMethods.getFormattedDate({
      date: +dateRange.start,
      timeZone: 'utc',
      format: 'ddd MMM DD, YYYY'
    });
    const formattedEndDate = dateMethods.getFormattedDate({
      date: +dateRange.end,
      timeZone: 'utc',
      format: 'ddd MMM DD, YYYY'
    });

    return [
      {
        val: `${formattedStartDate} to ${formattedEndDate}`,
        color: '#7440FB',
        id: 'selectedRange'
      }
    ];
  }

  /**
   *
   * @param {*} hasAttachments
   * @param {*} attachments
   */
  getAttachmentTextChip(hasAttachments, attachments, id) {
    if (!hasAttachments) {
      return [];
    }

    if (attachments.length) {
      return [
        { val: 'Attachments ' + attachments.join(', '), color: '#58e2c2', id }
      ];
    }
    return [{ val: 'All Attachments', color: '#58e2c2', id: 'hasAttachment' }];
  }
}
